import PropTypes from 'prop-types';
import portalContainerPropType from '../shared/portal/container_prop_type';
export var deprecatedSelectPlacements = ['bottom-end', 'bottom-start', 'top-end', 'top-start'];
var selectPlacements = ['bottom', 'top', ...deprecatedSelectPlacements];
var valueType = PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]).isRequired;
var option = {
  disabled: PropTypes.bool,
  flag: PropTypes.string,
  icon: PropTypes.element,
  label: PropTypes.string,
  value: valueType
};
var PopoverWidthStringPropType = ['auto', 'fit'];
var PopoverWidthPropType = PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf([...PopoverWidthStringPropType, PropTypes.number])]);
var propTypes = {
  clearIcon: PropTypes.bool,
  i18n: PropTypes.shape({
    clear: PropTypes.string.isRequired,
    noResults: PropTypes.string.isRequired,
    open: PropTypes.string.isRequired,
    searchPlaceholder: PropTypes.string.isRequired,
    selected: PropTypes.string.isRequired,
    showingResult: PropTypes.string.isRequired,
    showingResults: PropTypes.string.isRequired,
    unselected: PropTypes.string.isRequired
  }),
  id: PropTypes.string,
  multiple: PropTypes.bool,
  name: PropTypes.string,
  onChange: PropTypes.func,
  onClear: PropTypes.func,
  onScrollEnd: PropTypes.func,
  onSearch: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape(option).isRequired).isRequired,
  placeholder: PropTypes.string,
  placement: PropTypes.oneOf(selectPlacements),
  portalContainer: portalContainerPropType,
  preselectedOptions: PropTypes.arrayOf(PropTypes.shape(option).isRequired),
  readOnly: PropTypes.bool,
  scrollEndOffset: PropTypes.number,
  searchDelay: PropTypes.number,
  showSearch: PropTypes.bool,
  value: PropTypes.arrayOf(valueType),
  visibleOptions: PropTypes.number,
  className: PropTypes.string,
  defaultValue: PropTypes.arrayOf(valueType),
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.node,
  helperTextVisibility: PropTypes.oneOf(['auto', 'hidden', 'visible']),
  label: PropTypes.string,
  required: PropTypes.bool,
  separateLabel: PropTypes.bool,
  noTruncate: PropTypes.bool,
  wrap: PropTypes.bool,
  popoverWidth: PopoverWidthPropType,
  noWrap: PropTypes.bool
};
export default propTypes;